import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './StickyCtaButton.module.css';
import { useTranslation } from 'react-i18next';

interface StickyCtaButtonProps {
  show: boolean;
}

const StickyCtaButton: React.FC<StickyCtaButtonProps> = ({ show }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  if (!show) return null;

  return (
    <div className={styles.stickyCtaBar}>
      <div className={styles.stickyContent}>
        <span className={styles.stickyText}>
          {t('stickyButton.text')}
        </span>
        <button 
          className={styles.stickyButton}
          onClick={() => navigate('/create-content')}
        >
          {t('stickyButton.button')}
        </button>
      </div>
    </div>
  );
};

export default StickyCtaButton;
